import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../APIClient/APIClient";

export const getCustomerMaster = createAsyncThunk(
    'TPCRM/GetCustomer',
    async (databaseName,{ rejectWithValue }) => {
        try {
            const response = await apiClient.get(`/WGDealer/GetCustomer?databaseName=${databaseName}`);
            return response;
            
        } catch (error) {
            console.error('GetClinicDetails error:', error);
            return rejectWithValue(error.response?.data?.message || 'Failed to get clinic data');
        }
    }
);

//  const customerData = await GetData(
//             `${CustomerDataApi}?databaseName=${databaseName}`,
//             {
//               headers: {
//                 wg_token: jwtToken,
//               },
//             },
//             dispatch,
//             navigate
//           );